<ssc-layouted-overlay (closed)="isOpen = false" *ngIf="isOpen" title="Dev Tools">
  <div content>
    <visana-lib-button (click)="fillContactData()" variant="primary">Kontaktdaten ausfüllen </visana-lib-button>
    <visana-lib-button (click)="skipToAssistant()" variant="primary"
      >Skip to Assistant (choose language in footer before)
    </visana-lib-button>
    <p>
      If you want to validate the order, click on
      <strong>"{{ 'SUMMARY.NAVIGATION_BAR.ORDER_OFFER' | translate }}"</strong>
    </p>
  </div>

  <div primary-action>
    <visana-lib-button (click)="isOpen = false" buttonSize="small" variant="tertiary">Schliessen </visana-lib-button>
  </div>
</ssc-layouted-overlay>
<visana-lib-overlay-loader *ngIf="showLoader$ | async"></visana-lib-overlay-loader>
